import { Card, CardContent, CardHeader, Stack } from '@packages/shared';
import { useIntl } from 'react-intl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { ProductHintsItem } from '../ProductHintsItem';
import { messages } from './messages';

/*
 * INFO: As of right now the data structure for productHints and legalHints is the same, so the components are mostly identical.
 * The data for these two might change in the future and then the two components would have to be split again. For this reason we decided to split into seperate cards them from the start.
 */

const ProductHintsCardFragment = graphql(/* GraphQL */ `
  fragment ProductHintsCardFragment on Product {
    productHints {
      ...ProductHintsItemFragment
    }
  }
`);

export type ProductHintsCardProps = {
  /**
   * Product hints array from given product.
   */
  productHintsData: FragmentType<typeof ProductHintsCardFragment>;
};

/**
 * ProductHintsCard component displays all product hints
 * */
export const ProductHintsCard = ({ productHintsData }: ProductHintsCardProps) => {
  const { productHints } = getFragmentData(ProductHintsCardFragment, productHintsData);

  const { formatMessage } = useIntl();

  if (productHints.length === 0) return null;

  return (
    <Card>
      <CardHeader
        title={formatMessage(messages.productHintsCardHeader)}
        sx={{ borderBottom: 1, borderColor: 'grey.main', py: 1, px: 2 }}
      />
      <CardContent>
        <Stack spacing={1.5}>
          {productHints.map((productHint, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <ProductHintsItem data={productHint} key={idx} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
